import React, { useId } from 'react';
import styled from 'styled-components';

import { Text } from '../../Text';
import * as Theme from '../../styles/themeGetters';
import { Box } from '../../Box';

type SingleCheckboxProps = {
  register: (name) => { ref; onChange };
  name: string;
  label: string;
  title: string;
};

const Label = styled.label`
  font-size: ${Theme.getBaseUnit(4)};
  margin-left: 0.5rem;
`;

export const SingleCheckbox = ({
  register,
  name,
  label,
  title,
}: SingleCheckboxProps) => {
  const id = useId();
  return (
    <Box>
      <Text fontWeight="semibold" mt={6} mb={2}>
        {title}
      </Text>
      <input type="checkbox" {...register(name)} id={id} />
      <Label htmlFor={id}>{label}</Label>
    </Box>
  );
};
